import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash || hash === "#") {
      window.scrollTo(0, 0);
    } else {
      // Small delay to ensure content is rendered
      setTimeout(() => {
        const id = hash.replace("#", "");
        if (id) {
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, 100);
    }
  }, [pathname, hash]);

  return null;
}
